export default __webpack_public_path__ + "static/media/logo-bw.b1b46f5b.svg";